import React from "react";

const MainLayout = (props)=>(<main>{props.children}</main>)

MainLayout.isModal = false;

export default MainLayout